import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpFull = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 6, viewBox: "0 0 9 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.73795 5.60059C8.67325 5.60059 9.09665 4.43113 8.37813 3.83236L5.14018 1.13407C4.76934 0.825034 4.23066 0.825035 3.85982 1.13407L0.621863 3.83237C-0.0966511 4.43113 0.326754 5.60059 1.26205 5.60059L7.73795 5.60059Z", fill: "#DEDCD6" }));
const ForwardRef = forwardRef(SvgArrowUpFull);
export default ForwardRef;
